export class QueryStringGenerator {
	static generateQuery(data: unknown, titleCase?: boolean) {
		const newData = data as { [key: string | number]: unknown };

		const allKeys = Object.keys(newData);

		let queryString = '?';

		allKeys
			.filter(
				(key) =>
					newData[key] != undefined &&
					newData[key] != null &&
					String(newData[key]) != '',
			)
			.forEach((key, index) => {
				const data = newData[key];
				if (index != 0) queryString = queryString.concat('&');

				if (this.isArray(data)) {
					data.forEach((data, index) => {
						if (index != 0) queryString = queryString.concat('&');
						queryString = queryString.concat(
							`${titleCase ? this.titleCaseKey(key) : key}=${data}`,
						);
					});
					return;
				}

				queryString = queryString.concat(
					`${titleCase ? this.titleCaseKey(key) : key}=${data}`,
				);
			});

		return queryString == '?' ? '' : queryString;
	}

	private static isArray(data?: unknown): data is Array<unknown> {
		return !!(data as Array<unknown>)?.['some'];
	}

	private static titleCaseKey(key: string) {
		const splitedKey = key.split('');
		splitedKey[0] = splitedKey[0].toUpperCase();
		return splitedKey.join('');
	}
}
